(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["caravan-repairer-directory"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-repairer-directory]').forEach((directory) => {
    const search = directory.querySelector('[data-repairer-search]');
    const state = directory.querySelector('[data-repairer-state]');
    const mobile = directory.querySelector('[data-repairer-mobile]');
    const clear = directory.querySelector('[data-repairer-clear]');
    const count = directory.querySelector('[data-repairer-count]');
    const empty = directory.querySelector('[data-repairer-empty]');
    const grid = directory.querySelector('[data-repairer-grid]');
    const loading = directory.querySelector('[data-repairer-loading]');
    const pagination = directory.querySelector('[data-repairer-pagination]');
    const serverPagination = directory.querySelector('[data-repairer-server-pagination]');
    const previous = directory.querySelector('[data-repairer-previous]');
    const next = directory.querySelector('[data-repairer-next]');
    const pageStatus = directory.querySelector('[data-repairer-page-status]');
    const pageSize = 24;
    let currentPage = 1;
    let cards = [...directory.querySelectorAll('[data-repairer-card]')];
    const resultLabel = count.dataset.resultsLabel;
    serverPagination.hidden = true;
    [search, state, mobile, clear].forEach((control) => { control.disabled = true; });

    const render = () => {
      const term = search.value.trim().toLowerCase();
      const matches = cards.filter((card) => (!term || card.dataset.search.includes(term)) && (!state.value || card.dataset.state === state.value) && (!mobile.checked || card.dataset.mobile === 'true'));
      const totalPages = Math.max(1, Math.ceil(matches.length / pageSize));
      currentPage = Math.min(currentPage, totalPages);
      const start = (currentPage - 1) * pageSize;
      const finish = Math.min(start + pageSize, matches.length);
      cards.forEach((card) => { card.hidden = true; });
      matches.slice(start, finish).forEach((card) => { card.hidden = false; });
      count.textContent = `${matches.length} ${resultLabel}`;
      pageStatus.textContent = matches.length ? `${start + 1}–${finish} of ${matches.length}` : '0 of 0';
      previous.disabled = currentPage === 1;
      next.disabled = currentPage === totalPages;
      pagination.hidden = matches.length <= pageSize;
      empty.hidden = matches.length !== 0;
    };

    const applyFilters = () => {
      currentPage = 1;
      render();
    };

    [search, state, mobile].forEach((control) => control.addEventListener('input', applyFilters));
    clear.addEventListener('click', () => { search.value = ''; state.value = ''; mobile.checked = false; applyFilters(); search.focus(); });
    const showPage = (page) => {
      currentPage = page;
      render();
      directory.querySelector('.repairer-directory__results-line').scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    previous.addEventListener('click', () => { showPage(currentPage - 1); });
    next.addEventListener('click', () => { showPage(currentPage + 1); });

    const loadAllRepairers = async () => {
      let nextPath = directory.querySelector('[data-repairer-next-page]')?.getAttribute('href');
      let nextUrl = nextPath ? new URL(nextPath, window.location.href).href : '';
      const loadedUrls = new Set();
      try {
        while (nextUrl && !loadedUrls.has(nextUrl)) {
          loadedUrls.add(nextUrl);
          const response = await fetch(nextUrl, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Unable to load more repairers');
          const documentCopy = new DOMParser().parseFromString(await response.text(), 'text/html');
          documentCopy.querySelectorAll('[data-repairer-card]').forEach((card) => grid.appendChild(card));
          nextPath = documentCopy.querySelector('[data-repairer-next-page]')?.getAttribute('href');
          nextUrl = nextPath ? new URL(nextPath, nextUrl).href : '';
        }
        cards = [...directory.querySelectorAll('[data-repairer-card]')];
        cards.sort((a, b) => a.querySelector('h2').textContent.localeCompare(b.querySelector('h2').textContent)).forEach((card) => grid.appendChild(card));
        directory.classList.remove('repairer-directory--loading');
        loading.hidden = true;
        [search, state, mobile, clear].forEach((control) => { control.disabled = false; });
        render();
      } catch (error) {
        directory.classList.remove('repairer-directory--loading');
        loading.hidden = true;
        serverPagination.hidden = false;
        [search, state, mobile, clear].forEach((control) => { control.disabled = false; });
        cards = [...directory.querySelectorAll('[data-repairer-card]')];
        render();
      }
    };

    loadAllRepairers();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["claim-repairer-listing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-claim-listing]').forEach((section) => {
    const business = section.querySelector('[data-claim-business]');
    const value = new URLSearchParams(window.location.search).get('business');
    if (business && value) business.value = value;
    const success = section.querySelector('[data-claim-success]');
    if (success) success.focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
